var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHazardousActivities(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.529,
    height: 20
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 15902",
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Polygon 38"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.041 2.931a2 2 0 013.448 0l8.268 14.055A2 2 0 0120.033 20H3.5a2 2 0 01-1.724-3.014z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.765 3.445a.485.485 0 00-.431.246L3.066 17.746a.484.484 0 00-.003.502.484.484 0 00.434.252h16.536c.252 0 .38-.158.434-.252a.484.484 0 00-.003-.502L12.196 3.691a.485.485 0 00-.431-.246m0-1.5c.668 0 1.337.328 1.724.986l8.267 14.055C22.541 18.319 21.58 20 20.033 20H3.497c-1.547 0-2.508-1.68-1.724-3.014l8.268-14.055a1.982 1.982 0 011.724-.986z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 119",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M11.765 8.235v4.706"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 120",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M11.765 15.882h0"
  }))));
}
export default SvgHazardousActivities;


//////////////////
// WEBPACK FOOTER
// ./src/icons/hazardousActivities.svg
// module id = 460
// module chunks = 13